import axios, { AxiosRequestConfig } from 'axios';
import { DataResponse, PagedResponse } from '../types';
import { ParentReview } from '../types/ParentReview';

const URL = '/v2/sitter-parent-review';

class ParentReviewService {
  static getByFilter(config?: AxiosRequestConfig): Promise<PagedResponse<ParentReview>> {
    return axios.get(`${URL}`, config);
  }

  static delete(id: number, config?: AxiosRequestConfig): Promise<unknown> {
    return axios.delete(`${URL}/${id}`, config);
  }

  static patch(
    id: number,
    data: ParentReview,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<ParentReview>> {
    return axios.patch(`${URL}/${id}`, data, config);
  }

  static create(
    data: ParentReview,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<ParentReview>> {
    return axios.post(URL, data, config);
  }
}

export { ParentReviewService };
